<template>
<div class="task-type columns fixed-page">
  <div class="column main-column">
    <div class="task-type page" ref="page">
      <div class="task-type-header page-header flexrow-item" ref="header">
        <div class="flexcolumn-item flexrow">
          <router-link
            class="back-link flexrow-item"
            :to="{name: 'management-tasks'}"
          >
            <corner-left-up-icon size="1.4x" />
          </router-link>
          <div class="flexrow-item"></div>
          <task-type-name
            class="flexrow-item"
            style="font-size: 1.2em"
            :task-type="currentTaskType"
          />
          <!-- <div class="filler"></div>
          <div class="flexrow-item">
            <button-simple
              icon="upload"
              :title="$t('main.csv.import_file')"
              @click="showImportModal"
              v-if="!isActiveTab('schedule') && !isActiveTab('estimation')"
            />
          </div>
          <div class="flexrow-item">
            <button-simple
              icon="download"
              :title="$t('main.csv.export_file')"
              @click="onExportClick"
              v-if="!isActiveTab('schedule') && !isActiveTab('estimation')"
            />
          </div> -->
        </div>

        <div class="tabs mt1">
          <ul>
            <li :class="{'is-active': isActiveTab('tasks')}">
              <router-link :to="tasksPath">
                {{ $t('tasks.tasks')}}
              </router-link>
            </li>
            <!-- <li :class="{'is-active': isActiveTab('schedule')}">
              <router-link :to="schedulePath">
                {{ $t('schedule.title')}}
              </router-link>
            </li>
            <li :class="{'is-active': isActiveTab('estimation')}">
              <router-link :to="estimationPath">
                {{ $t('estimation.title')}}
              </router-link>
            </li> -->
          </ul>
        </div>

        <div
          class="flexcolumn-item flexrow"
        >
          <div
            class="flexrow-item field"
            v-if="isActiveTab('schedule') && isCurrentUserManager"
          >
            <date-field
              class="flexrow-item"
              :disabled-dates="startDisabledDates"
              :with-margin="false"
              :label="$t('main.start_date')"
              :can-delete="false"
              v-model="schedule.selectedStartDate"
            />
          </div>
          <div
            class="flexrow-item field"
            v-if="isActiveTab('schedule') && isCurrentUserManager"
          >
            <date-field
              class="flexrow-item"
              :disabled-dates="endDisabledDates"
              :with-margin="false"
              :label="$t('main.end_date')"
              :can-delete="false"
              v-model="schedule.selectedEndDate"
            />
          </div>

          <div
            class="flexrow-item color-option"
            v-if="isActiveTab('schedule')"
          >
            <combobox
              class="flexrow-item"
              :label="$t('tasks.colors.title')"
              :options="schedule.colorOptions"
              locale-key-prefix="tasks.colors."
              v-model="schedule.currentColor"
            />
          </div>
          <div
            class="flexrow-item zoom-level"
            v-if="isActiveTab('schedule')"
          >
            <combobox-number
              :label="$t('schedule.zoom_level')"
              :options="schedule.zoomOptions"
              v-model="schedule.zoomLevel"
              v-if="isActiveTab('schedule')"
            />
          </div>
        </div>
      </div>
      <!-- <div class="query-list">
        <search-query-list
          :queries="searchQueries"
          @change-search="changeSearch"
          @remove-search="removeSearchQuery"
          v-if="!loading.entities"
        />
      </div> -->

      <!-- <task-list
        ref="task-list"
        :tasks="tasks"
        :entity-type="entityType"
        :is-loading="loading.entities"
        :is-error="errors.entities"
        @task-selected="onTaskSelected"
        v-if="isActiveTab('tasks')"
      /> -->

      <table class="datatable">
        <thead ref="thead" class="datatable-head">
          <tr class="row-header">
            <th class="name" ref="th-name">
              {{ $t('tasks.fields.entity_name') }}
            </th>
            <th class="status" ref="th-status">
              {{ $t('tasks.fields.task_status') }}
            </th>
            <th class="assignees" ref="th-assignees">
              {{ $t('tasks.fields.assignees') }}
            </th>
            <th
              ref="th-estimation"
              class="estimation"
              :title="$t('main.estimation')"
            >
              {{ $t('tasks.fields.estimation').substring(0, 3) }}.
            </th>
            <th class="duration" ref="th-duration">
              {{ $t('tasks.fields.duration').substring(0, 3) }}.
            </th>
            <th class="start-date" ref="th-estimation">
              {{ $t('tasks.fields.start_date') }}
            </th>
            <th class="due-date" ref="th-estimation">
              {{ $t('tasks.fields.due_date') }}
            </th>
            <!-- <th class="real-start-date" ref="th-status">
              {{ $t('tasks.fields.real_start_date') }}
            </th>
            <th class="real-end-date" ref="th-status">
              {{ $t('tasks.fields.real_end_date') }}
            </th> -->
            <th class="last-comment-date" ref="th-status">
              {{ $t('tasks.fields.last_comment_date') }}
            </th>
            <th class="empty" ref="">
              &nbsp;
            </th>
          </tr>
        </thead>

        <tbody
          class="datatable-body"
        >
          <tr
            :ref="'task-' + pageTask.id"
            :class="{
              'task-line': true,
              'datatable-row': true,
              // 'dark-row': isRowDark(task),
              selected: selected
            }"
            :style="{
              background: rowColor
            }"
            @click="selectTask($event)"
          >
            <td class="name">
              {{ currentTaskType.name }}
            </td>
            <validation-cell
              class="status unselectable"
              :task-test="pageTask"
              :is-border="false"
              :is-assignees="false"
              :is-due-dates="false"
              :selectable="false"
              :is-static="true"
            />
            <multi-people-name-cell
              class="assignees"
              :peopleIds="pageTask.assignees"
            />
            <td class="estimation">
              <input
                v-if="isInDepartment && selected"
                :ref="pageTask.id + '-estimation'"
                class="input"
                @change="updateEstimationTasks($event.target.value)"
                :value="formatDuration(pageTask.estimation)"
              />
              <span v-else>
                {{ formatDuration(pageTask.estimation) }}
              </span>
            </td>
            <td :class="{
              duration: true,
              error: isEstimationBurned
            }">
              {{ formatDuration(pageTask.duration) }}
            </td>
            <td class="start-date">
              <date-field
                class="flexrow-item"
                :with-margin="false"
                :value="getDate(pageTask.start_date)"
                @input="updateStartDate"
                v-if="isInDepartment && selected"
              />
              <span v-else>
                {{ formatDate(pageTask.start_date) }}
              </span>
            </td>
            <td class="due-date">
              <date-field
                class="flexrow-item"
                :with-margin="false"
                :value="getDate(pageTask.due_date)"
                @input="updateDueDate"
                v-if="isInDepartment && selected"
              />
              <span v-else>
                {{ formatDate(pageTask.due_date) }}
              </span>

            </td>
            <td class="last-comment-date">
              {{ formatDate(pageTask.last_comment_date) }}
            </td>
            <td>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        class="task-type-schedule flexrow-item"
        v-if="isActiveTab('schedule')"
      >
        <schedule
          ref="schedule-widget"
          :start-date="schedule.startDate"
          :end-date="schedule.endDate"
          :hierarchy="schedule.scheduleItems"
          :zoom-level=schedule.zoomLevel
          :height="schedule.scheduleHeight"
          :is-loading="loading.entities"
          :is-estimation-linked="true"
          @item-changed="saveTaskScheduleItem"
          @root-element-expanded="expandPersonElement"
          @estimation-changed="updateEstimation"
        />
      </div>

      <div
        class="task-type-estimation flexrow-item"
        v-if="isActiveTab('estimation')"
      >
        <estimation-helper
          ref="estimation-widget"
          :entity-type="entityType"
          :tasks="tasks"
          @estimation-changed="updateEstimation"
        />
      </div>

      <import-render-modal
        :active="modals.isImportRenderDisplayed"
        :is-loading="loading.importing"
        :is-error="errors.importing"
        :import-error="errors.importingError"
        :parsed-csv="parsedCSV"
        :form-data="importCsvFormData"
        :columns="[...dataMatchers, ...optionalColumns]"
        :dataMatchers="dataMatchers"
        :database="{}"
        :disable-update=true
        @reupload="resetImport"
        @cancel="hideImportRenderModal"
        @confirm="uploadImportFile"
      />

      <import-modal
        ref="import-modal"
        :active="modals.importing"
        :is-loading="loading.importing"
        :is-error="errors.importing"
        :form-data="importCsvFormData"
        :columns="dataMatchers"
        :optional-columns="optionalColumns"
        @cancel="hideImportModal"
        @confirm="renderImport"
      />

    </div>
  </div>

  <div
    class="column side-column"
    v-show="nbSelectedTasks > 0"
  >
    <task-info
      :task="selectedTasks.values().next().value"
      :singleTask="nbSelectedTasks === 1"
    />
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { en, fr } from 'vuejs-datepicker/dist/locale'
import firstBy from 'thenby'
import moment from 'moment'
import { searchMixin } from '@/components/mixins/search'

import csv from '@/lib/csv'
import { buildSupervisorTaskIndex, indexSearch } from '@/lib/indexing'
import { sortPeople } from '@/lib/sorting'
import stringHelpers from '@/lib/string'
import {
  addBusinessDays,
  daysToMinutes,
  formatSimpleDate,
  getDatesFromStartDate,
  parseDate,
  minutesToDays,
  getDatesFromEndDate,
  parseSimpleDate
} from '@/lib/time'
import {
  applyFilters,
  getDescFilters,
  getExcludingKeyWords,
  getKeyWords,
  getTaskFilters
} from '@/lib/filtering'

import { formatListMixin } from '@/components/mixins/format'
import colors from '@/lib/colors'

import { CornerLeftUpIcon } from 'vue-feather-icons'
import DateField from '@/components/widgets/DateField'
import Combobox from '@/components/widgets/Combobox'
import ComboboxNumber from '@/components/widgets/ComboboxNumber'
import EstimationHelper from '@/components/pages/tasktype/EstimationHelper'
import Schedule from '@/components/pages/schedule/Schedule'
import TaskInfo from '@/components/sides/TaskInfo'
import TaskTypeName from '@/components/widgets/TaskTypeName'
import ImportModal from '@/components/modals/ImportModal'
import ImportRenderModal from '@/components/modals/ImportRenderModal'
import ValidationCell from '@/components/cells/ValidationCell'
import MultiPeopleNameCell from '@/components/cells/MultiPeopleNameCell'

export default {
  name: 'task-type-management-page',
  mixins: [formatListMixin, searchMixin],
  components: {
    CornerLeftUpIcon,
    Combobox,
    ComboboxNumber,
    DateField,
    EstimationHelper,
    Schedule,
    ImportModal,
    ImportRenderModal,
    TaskInfo,
    TaskTypeName,
    ValidationCell,
    MultiPeopleNameCell
  },

  entityListCache: [],

  data () {
    return {
      selected: false,
      pageTask: {},
      activeTab: 'tasks',
      currentSort: 'entity_name',
      currentScheduleItem: null,
      currentTask: null,
      entityType: 'Asset',
      tasks: [],
      selection: {},
      errors: {
        entities: false,
        importing: false,
        importingError: null
      },
      loading: {
        entities: false,
        importing: false
      },
      schedule: {
        currentColor: 'status',
        endDate: moment().add(3, 'months'),
        scheduleItems: [],
        scheduleHeight: 800,
        selectedEndDate: moment().add(3, 'months').toDate(),
        selectedStartDate: moment().add(-1, 'months').toDate(),
        startDate: moment().add(-1, 'months'),
        zoomLevel: 1,
        zoomOptions: [
          { label: '1', value: 1 },
          { label: '2', value: 2 },
          { label: '3', value: 3 }
        ],
        colorOptions: [
          { label: 'Neutral', value: 'neutral' },
          { label: 'Status', value: 'status' },
          { label: 'Late', value: 'late' }
        ]
      },
      modals: {
        isImportRenderDisplayed: false,
        importing: false
      },
      parsedCSV: [],
      importCsvFormData: {},
      optionalColumns: [
        'Estimation',
        'Start date',
        'Due date'
      ],
      dataMatchers: [
        'Parent',
        'Entity'
      ]
    }
  },

  created () {
    if (!this.currentProduction) {
      this.setProduction(this.$route.params.production_id)
    } else {
      const options = { productionId: this.currentProduction.id }
      if (this.currentEpisode) options.episodeId = this.currentEpisode.id
      this.$store.commit('RESET_PRODUCTION_PATH', options)
    }
  },

  mounted () {
    // this.updateActiveTab()
    // this.reload()
    this.reloadTask()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.resetScheduleHeight)
  },

  computed: {
    ...mapGetters([
      'assetMap',
      'assetsPath',
      'currentEpisode',
      'currentProduction',
      'currentTaskType',
      'editsPath',
      'editMap',
      'isCurrentUserManager',
      'isCurrentUserSupervisor',
      'isTVShow',
      'isDarkTheme',
      'nbSelectedTasks',
      'organisation',
      'personMap',
      'selectedTasks',
      'sequenceSubscriptions',
      'shotsByEpisode',
      'shotMap',
      'shotsPath',
      'taskSearchQueries',
      'taskStatusMap',
      'taskMap',
      'user'
    ]),

    isEstimationBurned () {
      return this.pageTask.estimation &&
        this.pageTask.estimation > 0 &&
        this.pageTask.duration > this.pageTask.estimation
    },

    isInDepartment () {
      if (this.isCurrentUserManager) {
        return true
      } else if (this.isCurrentUserSupervisor) {
        if (this.user.departments.length === 0) {
          return true
        } else {
          const taskType = this.currentTaskType
          return taskType.department_id && this.user.departments.includes(
            taskType.department_id)
        }
      } else {
        return false
      }
    },

    rowColor () {
      if (this.selected) {
        return this.isDarkTheme ? '#5e60ba' : '#bfc1ff'
      } else {
        if (this.pageTask.task_status_short_name === 'todo' && this.isDarkTheme) {
          return '#5f626a'
        }
        const baseColor = this.pageTask.task_status.color
        return colors.validationRowColor(baseColor, this.isDarkTheme)
      }
    },

    isSupervisorInDepartment () {
      const departments = this.user.departments || []
      return this.isCurrentUserManager ||
        (
          this.isCurrentUserSupervisor &&
          departments.includes((this.currentTaskType || {}).department_id)
        )
    },

    entityMap () {
      if (this.entityType === 'Asset') {
        return this.assetMap
      } else if (this.entityType === 'Shot') {
        return this.shotMap
      } else if (this.entityType === 'Edit') {
        return this.editMap
      }
      return this.assetMap
    },

    locale () {
      if (this.user.locale === 'fr_FR') {
        return fr
      } else {
        return en
      }
    },

    startDisabledDates () {
      return {
        to: parseDate(this.currentProduction.start_date).toDate(),
        from: this.schedule.endDate.toDate(),
        days: [6, 0]
      }
    },

    endDisabledDates () {
      return {
        to: this.schedule.startDate.toDate(),
        from: parseDate(this.currentProduction.end_date).toDate(),
        days: [6, 0]
      }
    },

    // Meta

    assetTasks () {
      return this.getTasks(Array.from(this.assetMap.values()))
    },

    shotTasks () {
      return this.getTasks(Array.from(this.shotMap.values()))
    },

    editTasks () {
      return this.getTasks(Array.from(this.editMap.values()))
    },

    title () {
      if (this.currentProduction) {
        if (this.isTVShow && this.currentEpisode) {
          const episodeName = this.currentEpisode.id === 'all'
            ? this.$t('main.all_assets')
            : this.currentEpisode.name
          return `${this.currentProduction.name} / ` +
                 `${episodeName} / ` +
                 `${this.currentTaskType.name}`
        } else {
          return `${this.currentProduction.name} / ${this.currentTaskType.name}`
        }
      } else {
        return 'Loading...'
      }
    },

    // Paths

    backPath () {
      let route = {}
      if (this.isActiveTab('schedule')) {
        route = {
          name: 'schedule',
          params: {
            production_id: this.currentProduction.id
          },
          query: { search: '' }
        }
      } else {
        if (this.currentTaskType.for_entity === 'Shot') {
          route = this.shotsPath
        }
        if (this.currentTaskType.for_entity === 'Asset') {
          route = this.assetsPath
        }
        if (this.currentTaskType.for_entity === 'Edit') {
          route = this.editsPath
        }
      }
      return {
        ...route,
        query: { search: '' }
      }
    },

    tasksPath () {
      return this.getRoute('task-type')
    },

    schedulePath () {
      return this.getRoute('task-type-schedule')
    },

    estimationPath () {
      return this.getRoute('task-type-estimation')
    },

    // Helpers

    sortOptions () {
      return [
        'entity_name',
        'task_status_short_name',
        'priority',
        'estimation',
        'duration',
        'retake_count',
        'due_date',
        'real_start_date',
        'end_date',
        'last_comment_date'
      ].map((name) => ({ label: name, value: name }))
    },

    searchQueries () {
      return this.taskSearchQueries.filter(
        t => t.entity_type === this.entityType
      )
    },

    scheduleTeam () {
      const scheduleTeam = this.currentProduction.team.map((personId) => {
        return this.personMap.get(personId)
      })
      return sortPeople(scheduleTeam)
    },

    scheduleWidget () {
      return this.$refs['schedule-widget']
    },

    searchField () {
      return this.$refs['task-search-field']
    }
  },

  methods: {
    ...mapActions([
      'addSelectedTask',
      'clearSelectedTasks',
      'initTaskType',
      'loadEpisodeScheduleItems',
      'loadScheduleItems',
      'loadProjectTasks',
      'loadTask',
      'removeTaskSearch',
      'saveScheduleItem',
      'saveTaskSearch',
      'setProduction',
      'subscribeToSequence',
      'updateTask',
      'unsubscribeFromSequence',
      'uploadTaskTypeEstimations'
    ]),

    updateStartDate (date) {
      Object.keys(this.selectionGrid).forEach(taskId => {
        let data = {
          start_date: null,
          due_date: null
        }
        const task = this.taskMap.get(taskId)
        const dueDate = task.due_date ? parseSimpleDate(task.due_date) : null
        if (date) {
          const startDate = moment(date)
          if (
            task.start_date &&
            task.start_date.substring(0, 10) === formatSimpleDate(startDate)
          ) return
          data = getDatesFromStartDate(
            startDate,
            dueDate,
            minutesToDays(this.organisation, task.estimation)
          )
        } else {
          data = {
            start_date: null,
            due_date: dueDate
          }
        }
        if (this.isTaskChanged(task, data)) {
          this.updateTask({ taskId, data })
            .catch(console.error)
        }
      })
    },

    updateDueDate (date) {
      Object.keys(this.selectionGrid).forEach(taskId => {
        let data = {
          start_date: null,
          due_date: null
        }
        const task = this.taskMap.get(taskId)
        const startDate = task.start_date ? parseSimpleDate(task.start_date) : null
        if (date) {
          const dueDate = moment(date)
          if (
            task.due_date &&
            task.due_date.substring(0, 10) === formatSimpleDate(dueDate)
          ) return
          data = getDatesFromEndDate(
            startDate,
            dueDate,
            minutesToDays(this.organisation, task.estimation)
          )
        } else {
          data = {
            start_date: startDate,
            due_date: null
          }
        }
        if (this.isTaskChanged(task, data)) {
          this.updateTask({ taskId, data })
            .catch(console.error)
        }
      })
    },

    updateEstimationTasks (days) {
      const estimation = daysToMinutes(this.organisation, days)
      this.updateTasksEstimation({ estimation })
    },

    reloadTask () {
      this.loadProjectTasks(this.currentProduction.id)
        .then(tasks => {
          tasks.forEach(task => {
            if (task.level === 1 && task.task_type_id === this.currentTaskType.id) {
              this.loadTask({ taskId: task.id })
                .then(() => {
                  this.pageTask = this.taskMap.get(task.id)
                })
            }
          })
        })
    },

    selectTask (event) {
      if (event && event.target && (
        // Dirty hack needed to make date picker and inputs work properly
        ['INPUT'].includes(event.target.nodeName) ||
        (
          event.target.parentNode &&
          ['HEADER'].includes(event.target.parentNode.nodeName)
        ) ||
        ['cell day selected'].includes(event.target.className)
      )) return

      const task = this.pageTask
      this.clearSelectedTasks({ task })
      if (this.selected) {
        this.selected = false
      } else {
        this.selected = true
        this.addSelectedTask({ task })
      }
    },

    getDate (date) {
      return date ? moment(date, 'YYYY-MM-DD').toDate() : null
    },

    updateEntityType () {
      this.isAssets = this.currentTaskType.for_shots === false
      if (this.currentTaskType.for_shots) {
        this.entityType = 'Shot'
      } else {
        this.entityType = 'Asset'
      }
      // this.isAssets = this.$route.path.includes('assets')
    },

    initData (force) {
      this.resetTasks()
      this.focusSearchField()
      if (this.tasks.length < 2) {
        this.loading.entities = true
        this.errors.entities = false
        this.initTaskType(force)
          .then(this.setCurrentScheduleItem)
          .then(() => {
            this.loading.entities = false
            this.resetTasks()
            this.focusSearchField()
            const searchQuery =
              this.searchField ? this.searchField.getValue() : ''
            if (searchQuery) this.onSearchChange(searchQuery)
            setTimeout(() => {
              this.setSearchFromUrl()
            }, 200)
            if (this.isActiveTab('schedule')) {
              this.resetScheduleItems()
              if (this.$refs['schedule-widget']) {
                this.$refs['schedule-widget'].scrollToToday()
              }
            }
          })
          .catch((err) => {
            console.error(err)
            this.loading.entities = false
            this.errors.entities = true
          })
      } else {
        this.loading.entities = true
        this.setCurrentScheduleItem()
          .then(() => {
            this.loading.entities = false
            if (this.isActiveTab('schedule')) {
              this.resetScheduleItems()
              if (this.$refs['schedule-widget']) {
                this.$refs['schedule-widget'].scrollToToday()
              }
            }
          })
      }
    },

    setCurrentScheduleItem () {
      if (this.isTVShow) {
        return this.loadEpisodeScheduleItems({
          production: this.currentProduction,
          taskType: this.currentTaskType
        })
          .then((items) => {
            if (!items) {
              Promise.resolve([])
            } else {
              this.currentScheduleItem = items.find((item) => {
                return (
                  item.task_type_id === this.currentTaskType.id &&
                  item.object_id === this.currentEpisode.id
                )
              })
              Promise.resolve(this.currentScheduleItem)
            }
          })
      } else {
        return this.loadScheduleItems(this.currentProduction)
          .then((items) => {
            if (!items) {
              Promise.resolve([])
            } else {
              this.currentScheduleItem = items.find((item) => {
                return item.task_type_id === this.currentTaskType.id
              })
              Promise.resolve(this.currentScheduleItem)
            }
          })
      }
    },

    // Tabs

    isActiveTab (tab) {
      return this.activeTab === tab
    },

    updateActiveTab () {
      if (this.$route.path.indexOf('schedule') > 0) {
        this.activeTab = 'schedule'
      } else if (this.$route.path.indexOf('estimation') > 0) {
        this.activeTab = 'estimation'
      } else {
        this.activeTab = 'tasks'
      }
    },

    getRoute (section) {
      const routeTaskTypeId = this.$route.params.task_type_id
      const taskTypeId =
        this.currentTaskType ? this.currentTaskType.id : routeTaskTypeId
      const route = {
        name: section,
        params: {
          production_id: this.currentProduction.id,
          task_type_id: taskTypeId
        }
      }
      if (this.isTVShow && this.currentEpisode) {
        route.name = `episode-${route.name}`
        route.params.episode_id = this.currentEpisode.id
      }
      return route
    },

    // Search

    onSearchChange (query) {
      if (query && query.length !== 1) {
        query = query.toLowerCase().trim()
        const descriptors = (this.currentProduction.descriptors || [])
          .filter(d => d.entityType === this.entityType)
        const keywords = getKeyWords(query) || []
        const excludingKeyWords = getExcludingKeyWords(query) || []
        const descFilters = getDescFilters(descriptors, query)
        if (
          keywords.length > 0 ||
          excludingKeyWords.length > 0 ||
          descFilters.length > 0
        ) {
          let tasks = []
          const filters = getTaskFilters(this.$options.taskIndex, query)
            .concat(descFilters)
          if (keywords.length > 0) {
            tasks = indexSearch(this.$options.taskIndex, keywords)
          } else {
            this.resetTasks()
            tasks = this.tasks
          }
          tasks = applyFilters(tasks, filters, this.taskMap)
          this.tasks = this.sortTasks(tasks)
          if (this.isActiveTab('schedule')) this.resetScheduleItems()
        } else {
          this.resetTasks()
          if (this.isActiveTab('schedule')) this.resetScheduleItems()
        }
      } else {
        this.resetTasks()
        if (this.isActiveTab('schedule')) this.resetScheduleItems()
      }
      this.setSearchInUrl()
      this.clearSelectedTasks()
    },

    saveSearchQuery (searchQuery) {
      const entityType = this.entityType
      this.saveTaskSearch({ searchQuery, entityType })
        .then(() => {
        })
        .catch((err) => {
          console.error(err)
        })
    },

    removeSearchQuery (searchQuery) {
      this.removeTaskSearch(searchQuery)
        .then(() => {
        })
        .catch((err) => {
          console.error(err)
        })
    },

    // Tasks

    onTaskSelected (task) {
      this.currentTask = task
    },

    resetTasks () {
      let tasks = this.assetTasks
      if (this.entityType === 'Shot') {
        tasks = this.shotTasks
      } else if (this.entityType === 'Edit') {
        tasks = this.editTasks
      }
      tasks = tasks.filter((task) => {
        const entity = this.entityMap.get(task.entity_id)
        return !entity.canceled
      })
      this.tasks = this.sortTasks(tasks)
      this.resetTaskIndex()
    },

    resetTaskIndex () {
      this.$options.taskIndex = buildSupervisorTaskIndex(
        this.tasks, this.personMap, this.taskStatusMap
      )
      this.$options.taskIndex.me =
        indexSearch(this.$options.taskIndex, this.user.full_name.split(' '))
    },

    reload () {
      this.updateEntityType()
      const isAssets = this.$route.path.includes('assets')
      const isShots = this.$route.path.includes('shots')
      this.entityType = isAssets ? 'Asset' : isShots ? 'Shot' : 'Edit'
      setTimeout(() => {
        this.initData(false)
        if (this.$refs['schedule-widget']) {
          this.$refs['schedule-widget'].scrollToToday()
        }
      }, 100)
      window.addEventListener('resize', this.resetScheduleHeight)
    },

    getTasks (entities) {
      const tasks = []
      entities.forEach(entity => {
        entity.tasks.forEach(taskId => {
          const task = this.taskMap.get(taskId.id || taskId)
          if (task) {
            // Hack to allow filtering on linked entity metadata.
            task.data = entity.data
            if (task.task_type_id === this.currentTaskType.id) {
              tasks.push(task)
            }
          }
        })
      })
      return tasks
    },

    sortTasks (tasks) {
      if (!tasks) tasks = this.tasks
      const isDesc = [
        'task_status_short_name',
        'entity_name',
        'due_date'
      ].includes(
        this.currentSort
      )
      return tasks.sort(
        firstBy(this.currentSort, isDesc ? 1 : -1)
          .thenBy('entity_name')
      )
    },

    onExportClick () {
      const taskLines = this.$refs['task-list'].getTableData()
      const nameData = [
        formatSimpleDate(moment()),
        this.currentProduction.name,
        this.currentTaskType.name,
        'tasks'
      ]
      if (this.currentEpisode) {
        nameData.splice(1, 0, this.currentEpisode.name)
      }
      const name = stringHelpers.slugify(nameData.join('_'))
      csv.buildCsvFile(name, taskLines)
    },

    updateEstimation ({ taskId, days, item }) {
      const estimation = daysToMinutes(this.organisation, days)
      const task = this.taskMap.get(taskId)
      let data = { estimation }
      if (!task.start_date) task.start_date = formatSimpleDate(moment())
      const startDate = parseDate(task.start_date)
      const dueDate = task.due_date ? parseDate(task.due_date) : null
      data = getDatesFromStartDate(
        startDate,
        dueDate,
        minutesToDays(this.organisation, estimation)
      )
      data.estimation = estimation
      if (item && !item.startDate) {
        item.startDate = parseDate(data.end_date)
      }
      if (item && !item.endDate) {
        item.endDate = parseDate(data.end_date)
      }
      if (item && item.startDate && item.endDate) {
        item.parentElement.startDate = this.getMinDate(item.parentElement)
        item.parentElement.endDate = this.getMaxDate(item.parentElement)
      }

      this.updateTask({ taskId, data })
        .catch(console.error)
    },

    // Schedule

    resetScheduleItems () {
      const taskAssignationMap = this.buildAssignationMap()
      let scheduleItems = this.scheduleTeam
        .map(person => this.buildPersonElement(person, taskAssignationMap))
        .filter(item => item)
        .filter(item => item.children.length > 0)

      if (taskAssignationMap.unassigned.length !== 0) {
        scheduleItems = scheduleItems.concat([
          this.buildPersonElement({ id: 'unassigned' }, taskAssignationMap)
        ])
      }
      this.schedule.scheduleItems = scheduleItems
    },

    buildAssignationMap () {
      const taskAssignationMap = { unassigned: [] }
      this.scheduleTeam.forEach((person) => {
        if (person) taskAssignationMap[person.id] = []
      })
      this.tasks.forEach((task) => {
        if (task.assignees.length > 0) {
          task.assignees.forEach((personId) => {
            if (!taskAssignationMap[personId]) {
              taskAssignationMap[personId] = []
            }
            taskAssignationMap[personId].push(task)
          })
        } else {
          taskAssignationMap.unassigned.push(task)
        }
      })
      return taskAssignationMap
    },

    buildPersonElement (person, taskAssignationMap) {
      if (!person) return null

      let manDays = 0
      let minStartDate
      let maxEndDate
      const personTasks = taskAssignationMap[person.id]

      let personElement
      if (person.id === 'unassigned') {
        personElement = {
          avatar: false,
          id: person.id,
          name: 'Unassigned',
          color: '#888',
          priority: 1,
          expanded: true,
          loading: false,
          children: [],
          editable: false
        }
      } else {
        personElement = {
          avatar: true,
          has_avatar: person.has_avatar,
          avatarPath: person.avatarPath,
          uniqueHash: person.uniqueHash,
          initials: person.initials,
          id: person.id,
          name: person.full_name,
          color: person.color,
          priority: 1,
          expanded: true,
          loading: false,
          children: [],
          editable: false
        }
      }

      const children = personTasks.map((task) => {
        const estimation = task.estimation
        let endDate

        let startDate = this.schedule.startDate.clone()
        if (task.start_date) {
          startDate = parseDate(task.start_date)
        } else if (task.real_start_date) {
          startDate = parseDate(task.real_start_date)
        }

        if (startDate.isAfter(this.schedule.endDate)) {
          startDate = this.schedule.endDate.clone().add(-1, 'days')
        }
        if (startDate.isBefore(this.schedule.startDate)) {
          startDate = this.schedule.startDate.clone()
        }

        if (task.due_date) {
          endDate = parseDate(task.due_date)
        } else if (task.end_date) {
          endDate = parseDate(task.end_date)
        } else if (task.estimation) {
          endDate = startDate.clone().add(estimation, 'days')
        }

        if (!endDate || endDate.isBefore(startDate)) {
          const nbDays = startDate.isoWeekday() === 5 ? 3 : 1
          endDate = startDate.clone().add(nbDays, 'days')
        }
        if (!endDate.isSameOrAfter(startDate)) {
          const nbDays = startDate.isoWeekday() === 5 ? 3 : 1
          endDate = startDate.clone().add(nbDays, 'days')
        }

        if (endDate.isAfter(this.schedule.endDate)) {
          endDate = this.schedule.endDate.clone().add(-1, 'days')
          if (startDate.isAfter(endDate)) {
            startDate = endDate.clone().add(-1, 'days')
          }
        }

        if (estimation) manDays += estimation
        if (!minStartDate || minStartDate.isAfter(startDate)) {
          minStartDate = startDate.clone()
        }
        if (!maxEndDate || maxEndDate.isBefore(endDate)) {
          maxEndDate = endDate.clone()
        }

        return {
          ...task,
          name: task.entity_name,
          startDate: startDate,
          endDate: endDate,
          expanded: false,
          loading: false,
          man_days: estimation,
          editable: this.isSupervisorInDepartment,
          unresizable: estimation > 0,
          parentElement: personElement,
          color: this.getTaskElementColor(task, endDate),
          children: []
        }
      })
      Object.assign(personElement, {
        children: children,
        startDate: minStartDate,
        endDate: maxEndDate,
        man_days: manDays
      })
      return personElement
    },

    getTaskElementColor (task, endDate) {
      if (this.schedule.currentColor === 'status') {
        let color = this.taskStatusMap.get(task.task_status_id).color
        if (color === '#f5f5f5') color = '#999'
        return color
      } else if (this.schedule.currentColor === 'late') {
        const isLate = (
          !this.taskStatusMap.get(task.task_status_id).is_done &&
          endDate.isBefore(moment())
        )
        return isLate ? '#FF3860' : '#999'
      } else {
        return null
      }
    },

    saveTaskScheduleItem (item) {
      if (!this.$options.savingBuffer) this.$options.savingBuffer = {}
      if (!this.$options.savingBuffer[item.id]) {
        this.$options.savingBuffer[item.id] = item
        setTimeout(() => {
          if (item.estimation) {
            item.endDate = addBusinessDays(
              item.startDate,
              Math.ceil(minutesToDays(this.organisation, item.estimation))
            )
          }
          item = { ...this.$options.savingBuffer[item.id] }
          if (item.startDate && item.endDate) {
            item.parentElement.startDate = this.getMinDate(item.parentElement)
            item.parentElement.endDate = this.getMaxDate(item.parentElement)
            this.updateTask({
              taskId: item.id,
              data: {
                start_date: item.startDate.format('YYYY-MM-DD'),
                due_date: item.endDate.format('YYYY-MM-DD')
              }
            })
          }
          this.$options.savingBuffer[item.id] = undefined
        }, 1000)
      } else {
        this.$options.savingBuffer[item.id] = item
      }
    },

    getMinDate (personElement) {
      let minDate = this.schedule.endDate.clone()
      personElement.children.forEach((item) => {
        if (item.startDate && item.startDate.isBefore(minDate)) {
          minDate = item.startDate
        }
      })
      return minDate.clone()
    },

    getMaxDate (personElement) {
      let maxDate = this.schedule.startDate.clone()
      personElement.children.forEach((item) => {
        if (item.endDate && item.endDate.isAfter(maxDate)) {
          maxDate = item.endDate
        }
      })
      return maxDate.clone()
    },

    expandPersonElement (personElement) {
      personElement.expanded = !personElement.expanded
    },

    resetScheduleHeight () {
      this.$nextTick(() => {
        if (this.isActiveTab('schedule')) {
          const pageHeight = this.$refs.page.offsetHeight
          const headerHeight = this.$refs.header.offsetHeight
          this.schedule.scheduleHeight = pageHeight - headerHeight + 20
          if (this.$refs['schedule-widget']) {
            this.$refs['schedule-widget'].resetScheduleSize()
          }
        }
      })
    },

    showImportModal () {
      this.modals.importing = true
    },

    hideImportModal () {
      this.modals.importing = false
    },

    showImportRenderModal () {
      this.modals.isImportRenderDisplayed = true
    },

    hideImportRenderModal () {
      this.modals.isImportRenderDisplayed = false
    },

    resetImport () {
      this.errors.importing = false
      this.errors.importingError = null
      this.hideImportRenderModal()
      this.importCsvFormData = undefined
      this.$refs['import-modal'].reset()
      this.showImportModal()
    },

    uploadImportFile (data) {
      const formData = new FormData()
      const filename = 'import.csv'
      const file = new File([data.join('\n')], filename, { type: 'text/csv' })

      formData.append('file', file)

      this.loading.importing = true
      this.errors.importing = false
      this.errors.importingError = null
      this.importCsvFormData = formData

      this.uploadTaskTypeEstimations(this.importCsvFormData) // to change
        .then(() => {
          this.loading.importing = false
          this.hideImportRenderModal()
        })
        .catch(err => {
          this.loading.importing = false
          this.errors.importingError = err
          this.errors.importing = true
        })
    },

    renderImport (data, mode) {
      this.loading.importing = true
      this.errors.importing = false
      if (mode === 'file') {
        data = data.get('file')
      }
      csv.processCSV(data)
        .then((results) => {
          this.parsedCSV = results
          this.hideImportModal()
          this.loading.importing = false
          this.showImportRenderModal()
        })
    }
  },

  watch: {
    currentTaskType () {
      this.reloadTask()
    },

    '$route.fullPath' () {
      this.updateEntityType()
      this.initData(true)
      this.updateActiveTab()
    },

    $route () {
      this.reload()
    },

    currentProduction () {
      this.initData(true)
      this.reload()
    },

    currentSort () {
      this.sortTasks()
      this.$refs['task-list'].resetSelection()
      this.clearSelectedTasks()
    },

    'schedule.currentColor' () {
      this.resetScheduleItems()
    },

    activeTab () {
      if (this.isActiveTab('schedule')) {
        this.resetScheduleItems()
        this.resetScheduleHeight()
        this.$nextTick(() => {
          if (this.$refs['schedule-widget']) {
            this.$refs['schedule-widget'].scrollToToday()
          }
        })
      }
    },

    currentScheduleItem () {
      if (this.currentScheduleItem) {
        this.schedule.startDate =
          parseDate(this.currentScheduleItem.start_date)
        this.schedule.endDate = parseDate(this.currentScheduleItem.end_date)
        this.schedule.selectedStartDate = this.schedule.startDate.toDate()
        this.schedule.selectedEndDate = this.schedule.endDate.toDate()
      }
    },

    'schedule.selectedStartDate' () {
      const newDate = formatSimpleDate(this.schedule.selectedStartDate)
      if (newDate !== this.currentScheduleItem.start_date) {
        this.schedule.startDate = parseDate(newDate)
        this.currentScheduleItem.startDate = this.schedule.startDate
        this.currentScheduleItem.endDate = this.schedule.endDate
        this.saveScheduleItem(this.currentScheduleItem)
      }
    },

    'schedule.selectedEndDate' () {
      const newDate = formatSimpleDate(this.schedule.selectedEndDate)
      if (newDate !== this.currentScheduleItem.end_date) {
        this.schedule.endDate = parseDate(newDate)
        this.currentScheduleItem.startDate = this.schedule.startDate
        this.currentScheduleItem.endDate = this.schedule.endDate
        this.saveScheduleItem(this.currentScheduleItem)
      }
    }
  },

  socket: {
    events: {
      'task:update' (eventData) {
        if (this.taskMap.get(eventData.task_id)) {
          setTimeout(this.resetTaskIndex, 1000)
        }
      }
    }
  },

  metaInfo () {
    return {
      title: `${this.title} - Kitsu`
    }
  }
}
</script>

<style scoped lang="scss">
.page-header {
  margin-top: 1em;
  margin-right: 0;
}

.tabs ul {
  margin-left: 0;
}

.page {
  flex: 1;
  height: 100%;
}

.back-link {
  padding-top: 5px;
  margin-right: 5px;
}

.task-type {
  display: flex;
  flex-direction: column;
  max-height: 100%;
}

.columns {
  display: flex;
  flex-direction: row;
}

.column {
  overflow-y: auto;
  padding: 0;
}

.main-column {
  border-right: 3px solid $light-grey;
  overflow: hidden;
}

.sorting-combobox {
  padding-top: 3px;
}

.field {
  margin: 0;
}

.query-list {
  margin-bottom: 0;
  margin-top: 0.2em;
  margin-left: 1em;
  min-height: 25px;
}

.push-right {
  flex: 1;
  text-align: right;
}

.task-type-schedule {
  flex: 1;
}

.zoom-level {
  margin-top: -8px;
}

.task-type-estimation {
  display: flex;
  max-height: calc(100% - 200px);
}

.name {
  font-weight: bold;
}
</style>
